import { call, select } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { getPcrBackupConfigSelector, getCurrentPcrBackupMetadata } from '../store/pcrBackup.selectors'
import { evaluateAndRunBackup } from '../services/pcrBackup.service'
import { IPcrBackupConfig, IPcrBackupMetadata } from '../store/pcrBackup.types'
import { IPcr } from '../../pcr/store/pcr.types'
import Logger from '../../../services/logger.service'

/**
 * Triggers a backup for the given PCR.
 * All gates (online, checksum, PRID) still apply.
 *
 * @param skipIntervalGate - true (default) to bypass the time interval check;
 *   pass false when the caller wants the interval gate enforced (e.g. online watcher).
 * @param metadataOverride - Pass DB-sourced metadata when Redux only holds
 *   the currently open chart (e.g. drain loop iterating multiple PCRs).
 */
export function* triggerBackup(pcr: IPcr, metadataOverride?: IPcrBackupMetadata, skipIntervalGate = true) {
  const authJwt: string = yield select(getAuthenticationJwtSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!authJwt || !serviceId) return
  const cachedMetadata: IPcrBackupMetadata = yield select(getCurrentPcrBackupMetadata)
  const config: IPcrBackupConfig = yield select(getPcrBackupConfigSelector)
  if (config.disabled) {
    Logger.info('triggerBackup: PCR backup is disabled via app settings')
    return
  }
  const metadata = metadataOverride ?? cachedMetadata
  try {
    yield call(evaluateAndRunBackup, pcr, serviceId, authJwt, metadata, skipIntervalGate, config)
  } catch (err) {
    Logger.errorObj('triggerBackup: Unhandled error', err)
  }
}
